<div class="system-page d-flex flex-column flex-root vh-100">
    <div class="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center p-5">

        <!--begin::Logo-->
        <div class="mb-4">
            <img [src]="logoSrc()" alt="HOAStart" class="system-page__logo">
        </div>
        <!--end::Logo-->

        <!--begin::Status Code-->
        @if (showStatusCode()) {
            <div class="system-page__code mb-3">{{ view().statusCode }}</div>
        }
        <!--end::Status Code-->

        <!--begin::Icon-->
        <!-- Takes the status code's place where reporting one would wrongly read as an error. -->
        @if (showIcon()) {
            <div class="system-page__icon mb-3" [class.system-page__icon--turning]="view().spinIcon" aria-hidden="true">
                <fa-duotone-icon [icon]="view().icon!" secondaryOpacity="0.4" />
            </div>
        }
        <!--end::Icon-->

        <!--begin::Heading-->
        <h1 class="system-page__heading h3 fw-semibold mb-3">{{ view().heading }}</h1>
        <!--end::Heading-->

        <!--begin::Description-->
        <p class="system-page__description text-body-secondary mb-4">{{ view().description }}</p>
        <!--end::Description-->

        <!--begin::Action-->
        @if (view().showButton) {
            @if (view().buttonAction) {
                <button type="button" class="btn btn-primary" (click)="view().buttonAction!()">{{ view().buttonText }}</button>
            } @else {
                <a [routerLink]="view().buttonUrl" class="btn btn-primary">{{ view().buttonText }}</a>
            }
        }
        <!--end::Action-->
    </div>
</div>
